function handleResponse(response) {
    return response.text().then(text => {
        const result = text && JSON.parse(text);
        if (!response.ok) {
            if(result.code === 200 || result.code === 422) {
                return result;
            } else if(result.code === 401) {

            } else {
                const error = (result && result.message) || response.statusText;
                return Promise.reject(error);
            }
        }
        return result;
    });
}

function retryResponse(url, data) {
    return fetch(url, data).then(response => response.json())
    .then(result => {
        return result;
    })
}
export { handleResponse }